// extracted by mini-css-extract-plugin
export default {"container":"UnauthorizedPage_container__wFFCe","title":"UnauthorizedPage_title__0tFEA","message":"UnauthorizedPage_message__oUO2C","homeLink":"UnauthorizedPage_homeLink__jx0nE"};